import { render, staticRenderFns } from "./NoDataCompareCard.vue?vue&type=template&id=2a4f6118&scoped=true"
import script from "./NoDataCompareCard.vue?vue&type=script&lang=js"
export * from "./NoDataCompareCard.vue?vue&type=script&lang=js"
import style0 from "./NoDataCompareCard.vue?vue&type=style&index=0&id=2a4f6118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f6118",
  null
  
)

export default component.exports